/* ==========================================================================
   ff-scroll-cta.js
   Upgrades any [data-ff-scroll-cta] anchor into a smooth scroll — but only
   when the target actually exists on the current page.

   If the target is missing (for example the section was reused on a page with
   no purchase form) the anchor keeps its href and behaves as a normal link.
   ========================================================================== */
(function () {
  'use strict';

  var Bus = window.FFBus;

  function resolveTarget(link) {
    var selector = link.getAttribute('data-scroll-target');
    if (selector) {
      var explicit = document.querySelector(selector);
      if (explicit) return explicit;
    }
    return document.querySelector('[data-ff-scroll-anchor]');
  }

  function onClick(event) {
    var link = event.currentTarget;
    var target = resolveTarget(link);
    if (!target) return; // let the browser follow the href

    event.preventDefault();

    var reduced = Bus ? Bus.prefersReducedMotion() : false;
    var top = target.getBoundingClientRect().top + window.scrollY - 24;
    window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });

    // Keyboard users should land on the controls, not just see them.
    var focusable = target.querySelector('input, select, button, a[href], [tabindex]');
    if (focusable) {
      window.setTimeout(
        function () {
          focusable.focus({ preventScroll: true });
        },
        reduced ? 0 : 400
      );
    }
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-ff-scroll-cta]').forEach(function (link) {
      if (link.dataset.ffScrollBound === 'true') return; // no duplicate listeners
      link.dataset.ffScrollBound = 'true';
      link.addEventListener('click', onClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind(document);
    });
  } else {
    bind(document);
  }

  // Theme Editor re-renders replace the DOM; rebind the fresh nodes only.
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
